module.exports = __webpack_public_path__ + "img/ar.aa7a9149.svg";